export const ticketTypes = {
    MAP: 1,
    MAP_NO_SEAT: 2,
    NO_SEAT: 3,
    SAVED: 4,
    NFC: 5,
}

interface OneTicket {
    id: string,
    ticketTemplateId: number,
    ticketName: string,
    type: number, // see ticketTypes
    amount: number,
    discount: number,
    fixedDiscount: number,
    label: string | undefined,
    area?: string,
    side?: string,
    row?: string,
    seat?: string,
    getPrice: () => number,
    masterTicket?: any,
    nfc?: any,
    rules?: any[]
}

export function isSeatsIoTicket(ticket: any): boolean {
    return !!ticket
        && 'label' in ticket
        && 'category' in ticket
        && 'labels' in ticket
        && 'label' in ticket['category']
        && 'own' in ticket['labels']
        && 'parent' in ticket['labels']
        && 'section' in ticket['labels']
}

export function isSeatsIoNoSeatTicket(ticket: any): boolean {
    return !!ticket
        && 'label' in ticket
        && 'category' in ticket
        && 'capacity' in ticket
        && 'labels' in ticket
        && 'label' in ticket['category']
        && 'own' in ticket['labels']
}

export function isNoSeatTicket(ticket: any): boolean {
    return !!ticket
        && 'count' in ticket
        && 'price' in ticket
        && !('area' in ticket)
        && !isNfcTicket(ticket)
}

export function isNfcTicket(ticket: any): boolean {
    return !!ticket
        && 'masterTicket' in ticket
}

export function hasSeatTicket(ticket: any): boolean {
    return !!ticket
        && 'area' in ticket
        && 'row' in ticket
        && 'seat' in ticket
        && ticket.seat
}

export function getSeatLabel(ticket: { area: string, side: string | undefined, row: string, seat: string }) {
    return `${ticket.area} ${getSeatSideLabel(ticket.side)} ${ticket.row} ${ticket.seat}`
}

export function getSeatSideLabel(side: any) {
    return side === 'L' && 'Left'
        || side === 'R' && 'Right'
        || side === 'M' && 'Center'
        || '';
}

const getTicketPriceInternal = (ticket: any) => {
    let additionalDiscount = 0;

    if (ticket.rules) {
        for (const rule of ticket.rules) {
            if (rule.type === 1) {
                additionalDiscount += rule.price;
            }
            else if (rule.type === 2) {
                additionalDiscount += ticket.amount * (rule.price / 100.0);
            }
        }
    }

    return ticket.amount * (100 - ticket.discount) / 100 - ticket.fixedDiscount - additionalDiscount;
}

export function seatsIoObjectToTicket(obj: any, pricing: any[]): OneTicket {

    const [area, side] = !!obj.labels.section ? obj.labels.section.split("-") : ['', ''];
    const ticket = {
        id: obj.id,
        ticketTemplateId: pricing.find(t => t.category.toString() === obj.category.key.toString()).ticketTemplateId,
        ticketName: obj.category.label,
        type: 'capacity' in obj ? ticketTypes.MAP_NO_SEAT : ticketTypes.MAP,
        amount: obj.pricing.price,
        discount: 0,
        fixedDiscount: 0,
        label: obj.label,
        area,
        side,
        row: obj.labels.parent,
        seat: obj.labels.own,
        getPrice: () => 0,
    }

    ticket.getPrice = () => getTicketPriceInternal(ticket);

    return ticket;
}

export function NoSeatProductToTicket(obj: any): OneTicket {

    const ticket = {
        id: obj.ticketTemplateId,
        ticketTemplateId: obj.ticketTemplateId,
        ticketName: obj.name,
        type: ticketTypes.NO_SEAT,
        amount: obj.price,
        discount: 0,
        fixedDiscount: 0,
        label: obj.name,
        getPrice: () => 0,
    }

    ticket.getPrice = () => getTicketPriceInternal(ticket);

    return ticket;
}

export function NfcToTicket(sourceTicket: any, ticketTemplate: any): OneTicket {

    const ticket = {
        id: ticketTemplate.ticketTemplateId,
        ticketTemplateId: ticketTemplate.ticketTemplateId,
        ticketName: ticketTemplate.name,
        type: ticketTypes.NFC,
        amount: ticketTemplate.price,
        discount: 0,
        fixedDiscount: 0,
        label: ticketTemplate.name,
        area: sourceTicket.area,
        side: sourceTicket.side,
        row: sourceTicket.row,
        seat: sourceTicket.seat,
        getPrice: () => 0,
    }

    ticket.getPrice = () => getTicketPriceInternal(ticket);

    return ticket;
}

export function MembershipToSeasonPassTicket(sourceTicket: any, ticketTemplate: any): OneTicket {

    const ticket = {
        id: ticketTemplate.ticketTemplateId,
        ticketTemplateId: ticketTemplate.ticketTemplateId,
        ticketName: ticketTemplate.name,
        type: ticketTypes.NFC,
        amount: ticketTemplate.price,
        discount: 0,
        fixedDiscount: 0,
        label: ticketTemplate.name,
        area: sourceTicket.area,
        side: sourceTicket.side,
        row: sourceTicket.row,
        seat: sourceTicket.seat,
        getPrice: () => 0,
    }

    ticket.getPrice = () => getTicketPriceInternal(ticket);

    return ticket;
}

export function OfferSeatsToTicket(sourceSeat: any): OneTicket {

    const ticket = {
        id: sourceSeat.ticketTemplateId,
        ticketTemplateId: sourceSeat.ticketTemplateId,
        ticketName: sourceSeat.ticketName,
        type: ticketTypes.SAVED,
        amount: sourceSeat.amount,
        discount: 0,
        fixedDiscount: sourceSeat.fixedDiscount,
        label: sourceSeat.ticketName,
        area: sourceSeat.area,
        side: sourceSeat.side,
        row: sourceSeat.row,
        seat: sourceSeat.seat,
        getPrice: () => 0,
    }

    ticket.getPrice = () => getTicketPriceInternal(ticket);

    return ticket;
}